/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserWorkflowStepStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  SKIPED = 'SKIPED',
}
